export default __webpack_public_path__ + "static/media/fanucZeta.d5162f96.JPG";